import Icon from '@vfz/ui/dist/components/icon/icon';
import React, { useEffect, useState } from 'react';

import * as S from './loader.styles';

interface ILoaderProps extends React.SVGAttributes<SVGElement> {
  delay?: number;
  inline?: boolean;
  noPadding?: boolean;
}

export const Loader = ({ delay = 300, inline = false, noPadding = false }: ILoaderProps) => {
  const [show, setShow] = useState(false);
  let timeout: NodeJS.Timeout;

  useEffect(() => {
    if (delay === 0) {
      setShow(true);
    }

    timeout = setTimeout(() => {
      setShow(true);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <S.SpinnerContainer data-testid="loader" inline={inline} noPadding={noPadding}>
      <Icon name="loading" />
      <S.ScreenreaderOnly>Bezig met laden...</S.ScreenreaderOnly>
    </S.SpinnerContainer>
  );
};
